import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  @Input() exibeMenu : boolean;
  @Input() siglaMarca: string = "FL";

  constructor() { }

  ngOnInit() {
  }

  close() {
    window.open('location', '_self', '').close();
  }

}
